import { Filter } from './filter';
import { SecondaryFacttable, JoinCriteria } from './secondary-facttable';

export class ReportDefinition {

    name?: string;
    factTableId?: string;
    measureIds: string[] = [];
    leftDimensionAttributeIds: string[] = [];
    topDimensionAttributeIds: string[] = [];
    filters: Filter[] = [];
    hideEmptyColumns: boolean = false;
    secondaryFacttables: SecondaryFacttable[] = [];

    constructor(factTableId: string|undefined, measureIds: string[], leftDimensionAttributeIds: string[], topDimensionAttributeIds: string[], filters?: Filter[], hideEmptyColumns?: boolean, secondaryFacttables?: SecondaryFacttable[]) {
        this.factTableId = factTableId;
        this.measureIds = measureIds;
        this.leftDimensionAttributeIds = leftDimensionAttributeIds;
        this.topDimensionAttributeIds = topDimensionAttributeIds;
        this.filters = filters || [];
        if(hideEmptyColumns === undefined){
            this.hideEmptyColumns = false;
        } else {
            this.hideEmptyColumns = hideEmptyColumns;
        }
        let slimSecondaryFacttables: SecondaryFacttable[] = [];
        if(secondaryFacttables && secondaryFacttables.length>0){
            for(let secondaryFacttable of secondaryFacttables){
                let slimSecondaryFacttable = new SecondaryFacttable();
                slimSecondaryFacttable.factId = secondaryFacttable.facttable?.id;
                slimSecondaryFacttable.join = secondaryFacttable.joinType?.type ?? '';
                slimSecondaryFacttable.measureIds = secondaryFacttable.measureIds;
                for(let joinCriteria of secondaryFacttable.joinCriterias){
                    let slimJoinCriteria = new JoinCriteria();
                    slimJoinCriteria.leadingRolePlayingDimensionId = joinCriteria.leadingDimension?.id;
                    slimJoinCriteria.secondaryRolePlayingDimensionId = joinCriteria.secondaryDimension?.id;
                    slimSecondaryFacttable.joinCriterias.push(slimJoinCriteria);
                }
                slimSecondaryFacttables.push(slimSecondaryFacttable);
            }
            this.secondaryFacttables = slimSecondaryFacttables;
        }
    }
}
